import { EuiButtonIcon } from "@inscopix/ideas-eui";
import { Tooltip } from "components/Tooltip/Tooltip";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import { usePinToolMutation, useUnpinToolMutation } from "./ToolBrowser.api";
import { Tool } from "graphql/_Types";

export interface ButtonPinToolProps {
  toolId: Tool["id"];
  pinned: boolean;
}

export const ButtonPinTool = ({ pinned, toolId }: ButtonPinToolProps) => {
  const { mutateAsync: pinTool, isLoading: isPinning } = usePinToolMutation();
  const { mutateAsync: unpinTool, isLoading: isUnpinning } =
    useUnpinToolMutation();
  const isLoading = isPinning || isUnpinning;

  const onClick = async () => {
    if (pinned) {
      try {
        await unpinTool(toolId);
      } catch (error) {
        addUtilityToastFailure("Failed to unpin tool");
      }
    } else {
      try {
        await pinTool(toolId);
      } catch (error) {
        addUtilityToastFailure("Failed to pin tool");
      }
    }
  };

  return (
    <Tooltip
      content={pinned ? "Unpin tool" : "Pin tool to top"}
      delayShow={500}
    >
      <EuiButtonIcon
        aria-label={pinned ? "Unpin tool" : "Pin tool"}
        onClick={() => void onClick()}
        isLoading={isLoading}
        iconType={pinned ? "starFilled" : "starEmpty"}
        iconSize={isLoading ? "m" : "l"}
        color={"text"}
        size="s"
      />
    </Tooltip>
  );
};
